"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REPEAT_USER_MONTHLY_TERM = exports.NEW_USER_MONTHLY_TERM = exports.LocalizationConstants = exports.HYDRA_TEST_URL = exports.FreePrivacyDisabled = exports.EidConstants = void 0;
/* eslint-disable max-len */
const HYDRA_TEST_URL = exports.HYDRA_TEST_URL = 'https://hydra.test-godaddy.com/v2/no-header/uxp-tester/en-US/1/3?currency=USD&https=true&local=false&uxcore=false&react=17&delayjs=false&optOut=false&backLink=&preloadjs=false&bot=false';
const EidConstants = exports.EidConstants = {
  APP: 'dpp-search',
  BACK: 'back.click',
  SEARCH: 'search.click'
};
const LocalizationConstants = exports.LocalizationConstants = {
  MARKET_COOKIE_KEY: 'market',
  CURRENCY_COOKIE_KEY: 'currency',
  MARKET_SEPARATOR: '-',
  MARKET_PARTS_LENGTH: 2,
  DEFAULT_MARKET: 'en-US',
  DEFAULT_CURRENCY: 'USD'
};
const FreePrivacyDisabled = exports.FreePrivacyDisabled = ['am', 'com.au', 'net.au', 'org.au', 'jp', 'co.jp', 'kr', 'co.kr', 'ne.kr', 're.kr', 'no', 'co.nz', 'net.nz', 'org.nz', 'vg', 'sg', 'com.sg', 'tw', 'com.tw', 'net.tw', 'org.tw', 'us'];
const REPEAT_USER_MONTHLY_TERM = exports.REPEAT_USER_MONTHLY_TERM = 60;
const NEW_USER_MONTHLY_TERM = exports.NEW_USER_MONTHLY_TERM = 24;